<div class="ab-notice-view__header">
  <div class="ab-notice-view__back d-lg-none">
    <a
      class="btn d-block"
      uiSref="project-errors"
      [uiParams]="{ projectId: group.projectId }"
    >
      <i class="glyphicon glyphicon-angle-left"></i>
    </a>
  </div>
  <h1
    class="notice-title"
    (click)="group.detailedMessageView = !group.detailedMessageView"
    [ngClass]="{ 'text-truncate': !group.detailedMessageView }"
    title="{{ notice.errors[0].message }}"
  >
    <span class="notice-title__name" *ngIf="notice.errors[0].type">
      {{ notice.errors[0].type }}:&nbsp;
    </span>
    {{ notice.errors[0] | errorMessageWithoutType }}
  </h1>
  <div class="ab-notice-view__button flex-shrink-0">
    <button
      class="btn btn-holder"
      id="toggle-state"
      type="button"
      *ngIf="group.resolved"
      (click)="unresolveGroup(group)"
    >
      <i class="glyphicon glyphicon-exclamation-triangle"></i>
      &nbsp;Unresolve
    </button>
    <button
      class="btn btn-holder"
      id="toggle-state"
      type="button"
      *ngIf="!group.resolved"
      (click)="resolveGroup(group)"
    >
      <div class="glyphicon glyphicon-check-circle"></div>
      &nbsp;Resolve
    </button>
  </div>
</div>

<div class="ab-notice-view__body d-md-flex flex-md-column flex-md-grow-1">
  <ul
    ngbNav
    #nav="ngbNav"
    class="nav-tabs"
    [(activeId)]="activeTabIndex"
    [destroyOnHide]="false"
    (navChange)="onNavChange($event)"
  >
    <li [ngbNavItem]="'ngb-tab-0'" *ngIf="tabGroups[0][0].isVisible">
      <a ngbNavLink>
        <span>{{ tabGroups[0][0].title }}</span>
      </a>
      <ng-template ngbNavContent>
        <ab-notice-overview
          *ngIf="tabGroups[0][0].active"
          [project]="project"
          [group]="group"
          [notice]="notice"
          [chart]="chart"
          [groupDeployAvailable]="groupDeployAvailable"
          [loadingChart]="loading"
          [dur]="dur"
          [lastN]="lastN"
          [deployRevision]="deployRevision"
          [deletingGroup]="deletingGroup"
          (loadChart)="loadChart($event)"
          (groupMuted)="muteGroup($event)"
          (groupUnmuted)="unmuteGroup($event)"
          (groupDeleted)="deleteGroup()"
        ></ab-notice-overview>
      </ng-template>
    </li>

    <li
      [ngbNavItem]="'ngb-tab-1'"
      *ngIf="tabGroups[1][0].isVisible || tabGroups[1][1].isVisible"
    >
      <a ngbNavLink>
        <span>{{ tabGroups[1][0].title }}</span>
        <span class="tab-heading-counter">{{
          noticeCount | numberToHuman
        }}</span>
      </a>
      <ng-template ngbNavContent>
        <div class="ab-notice-view__tab">
          <ab-notice-detail
            *ngIf="tabGroups[1][0].active"
            [project]="project"
            [group]="group"
            [noticeCount]="noticeCount"
            [occurrence]="notice"
            [activeFilters]="activeFilters"
            [filters]="filters"
            (toggleOccurrenceList)="toggleOccurrenceList()"
          ></ab-notice-detail>
          <ab-notice-list
            *ngIf="tabGroups[1][1].active"
            [group]="group"
            [activeNotice]="notice"
            [activeFilters]="activeFilters"
            [filters]="filters"
          ></ab-notice-list>
        </div>
      </ng-template>
    </li>

    <li [ngbNavItem]="'ngb-tab-2'" *ngIf="tabGroups[2][0].isVisible">
      <a ngbNavLink>
        <span>{{ tabGroups[2][0].title }}</span>
      </a>
      <ng-template ngbNavContent>
        <div class="ab-notice-view__tab">
          <ab-attr-list
            *ngIf="tabGroups[2][0].active"
            [project]="project"
            [group]="group"
          ></ab-attr-list>
        </div>
      </ng-template>
    </li>

    <li [ngbNavItem]="'ngb-tab-3'" *ngIf="tabGroups[3][0].isVisible">
      <a ngbNavLink>
        <span>{{ tabGroups[3][0].title }}</span>
        <span class="tab-heading-counter" *ngIf="group.commentCount > 0">
          {{ group.commentCount }}
        </span>
      </a>
      <ng-template ngbNavContent>
        <div class="ab-notice-view__tab">
          <ab-comment-list
            *ngIf="tabGroups[3][0].active"
            [user]="user"
            [group]="group"
          ></ab-comment-list>
        </div>
      </ng-template>
    </li>
  </ul>

  <div [ngbNavOutlet]="nav"></div>
</div>
